import { Event } from "../../contracts";

export const mapTeamNames = (x: Event): Event => {
    const swapArray = x.isTeamSwap ? [1, 0] : [0, 1];
    x.team1name = x.participants[swapArray[0]].name;
    x.team2name = x.participants[swapArray[1]].name;
    return x;
}